import { createAsyncThunk } from '@reduxjs/toolkit';

import { PartnerDocType } from '@/modules/partner/model/partner-doc-type';
import { namespace } from '@/modules/partner/namespace';
import { partnerUploadSelectors } from '@/modules/partner/store/uploadSlice';
import type { RootState } from '@/root-store';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { updateUploadFormValue } from '../actions';

type Params = {
  docType: PartnerDocType;
  onSuccess?: () => void;
};

const prepareUploadPartnerForm = createAsyncThunk(
  `${namespace}/prepare-upload-partner-form`,
  async ({ docType, onSuccess }: Params, { getState, dispatch }): Promise<ThunkResult> => {
    dispatch(updateUploadFormValue({ docType }));

    const values = partnerUploadSelectors.getValuesForUploadForm(getState() as RootState);

    dispatch(
      updateUploadFormValue({
        expiresAt: values?.expiresAt,
        file: values?.file,
        status: values?.status,
        rejectReason: values?.rejectReason,
      }),
    );

    onSuccess?.();

    return { isSucceed: true };
  },
);

export { prepareUploadPartnerForm };
